import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AUTH_SESSION } from '@shared/di/auth-session.token';
import { LoggerService } from '@shared/services/logger.service';

@Component({
  selector: 'app-not-implemented',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonModule,
  ],
  providers: [],
  template: `
    <div
      class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
      <div class="flex flex-col items-center justify-center">
        <img src="assets/images/logos/Logo_DDH.png" alt="Drop logo" class="mb-20 w-36 shrink-0">
        <div
          style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, rgba(204, 0, 102, 0.4) 10%, rgba(204, 0, 102, 0) 30%);">
          <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-20 sm:px-20 flex flex-col items-center"
               style="border-radius:53px">
            <span class="text-blue-500 font-bold text-3xl">Ops...</span>
            <h1 class="text-surface-900 dark:text-surface-0 font-bold text-2xl lg:text-3xl mb-2">Stiamo ancora lavorando
              per rilasciare questa funzionalità.</h1>
            <p-button (onClick)="logout()" label="Esci"></p-button>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class NotImplementedComponent {
  private logger = inject(LoggerService);
  private authService = inject(AUTH_SESSION);

  logout() {
    return this.authService.logout(true, 'auth/login');
  }
}
